import { Component, OnInit, NgZone, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ScrollDispatcher} from '@angular/cdk/overlay';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() menuList$: any;
  @Input() memberInfo$: any;

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public isOpen: boolean;
  public isScroll = false;
  public isMobileOn: boolean;
  public isFullpage: boolean; // 전체 메뉴
  public menu_on = '';

  public memberInfo: any = {};
  public menuList: any = [];

  /*******************************************************************************
     설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private scrollDispatcher: ScrollDispatcher,
    private zone: NgZone,
  ) {
    this.scrollDispatcher.scrolled().subscribe( (x) => {
      // 모바일 제외
      if ( window.innerWidth > 720 ) {
        if (window.pageYOffset > 0) {
          if ( this.isScroll === false ) {
            this.zone.run( () => { this.isScroll = true; });
          }
        } else {
          if ( this.isScroll === true ) {
            this.zone.run( () => { this.isScroll = false; });
          }
        }
      } else {
        if ( this.isScroll === true ) {
          this.zone.run( () => { this.isScroll = false; });
        }
      }
    });
  }

  /*******************************************************************************
     설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit() {
    this.isOpen = false;
    this.menu_on = '0';

    this.memberInfo$.subscribe(data => {
      this.memberInfo = data;
    });

    this.menuList$.subscribe( (menuList: any) => {
      if (menuList.length > 0) {
        const mainMenu = menuList[1];

        try {
          const getMenuList = function getMenu(list, menu) {
            if (list.children === undefined) {
              for (const element of list) {
                if (element.mainmenu_view_yn === '1') {
                  menu.push(element);
                  continue;
                } else {
                  getMenu(element, menu);
                }
              }
            }
          };
          getMenuList(mainMenu, this.menuList);
        } catch (e) {
          console.log(e);
          return false;
        }
      }
    });

  }

   /*******************************************************************************
    설  명 : 메뉴명 클릭 시
    입력값 : event = 이벤트, href = 주소
    리턴값 : true / false
  *******************************************************************************/
  goLink( event, menu, menu_on ) {
    // 모바일 메뉴처리
    if (event.view.innerWidth < 720 && menu_on > -1) {
      if (this.menu_on === menu_on) {
        this.menu_on = '0';
      } else {
        this.menu_on = menu_on;
      }
      return;
    }

    this.closeMenu1();
    let href = menu[0].link_url;
    let boardId = menu[0].board_id;
    let menuIndex = menu[0].seq;

    if (href === '') {
      let result = false;
      const link = function getURL(item) {
        if (item.link_url === '' && item.board_id === '') {
          for (const element of item.children) {
            getURL(element);
            if (result) {
              return false;
            }
          }
        } else {
          href = item.link_url;
          boardId = item.board_id;
          menuIndex = item.seq;
          result = true;
        }
      };
      link(menu[0]);
    }

    if ( event.view.innerWidth > 1400 || menu_on < 0 ) {
      if ( (boardId || '') === '' ) {
        this.router.navigate([ '/en' + href ], { queryParams: { menu_seq: menuIndex }});
      } else {
        this.router.navigate([ (href !== '' ? href : '/en/board/list') ], { queryParams: { board_id: boardId } });
      }
    }
  }

  /*******************************************************************************
    설  명 : 서브메뉴명 클릭 시 메뉴 닫기 (전체메뉴, 모바일메뉴)
    입력값 :
    리턴값 :
  *******************************************************************************/
  closeMenu1() {
    this.isMobileOn = false;
    this.isFullpage = false;
  }

  /*******************************************************************************
     설  명 : 메뉴펼치기
    입력값 :
    리턴값 :
  *******************************************************************************/
  expandMenu() {
    this.isOpen = true;
  }

  /*******************************************************************************
     설  명 : 메뉴닫기
    입력값 :
    리턴값 :
  *******************************************************************************/
  closeMenu() {
      this.isOpen = false;
  }

  /*******************************************************************************
     설  명 : 스크롤시 header 색상 변경
    입력값 :
    리턴값 :
  *******************************************************************************/
  scroll = (event): void => {
    if(window.pageYOffset > 0) {
      this.isScroll = true;
    } else {
      this.isScroll = false;
    };
  };
}
